import type {Dispatch} from "redux";
import type {Action} from "@App/state/actions";
import {ActionType} from "@App/state/action-types";
import type {DriverDataSuccessResponse} from "@App/apis/rest/ayvens/driverData/driverDataSuccessResponse";

export const setUserId = (userId: string) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.SET_USER_ID,
            payload: userId
        })
    }
}


export const setDriverData = (driverData: DriverDataSuccessResponse) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.SET_DRIVER_DATA,
            payload: driverData
        })
    }
}
